"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const RegionSelectorHeader_1 = __importDefault(require("../RegionSelectorHeader/RegionSelectorHeader"));
const RegionSelectorFooter_1 = __importDefault(require("../RegionSelectorFooter/RegionSelectorFooter"));
const FlexContainer = (0, styled_components_1.default)('div') `
  display: flex;
  flex-direction: column;
  min-width: 260px;
`;
const RegionSwitcherContent = ({ children, id, onClose, onSelect, }) => {
    return ((0, jsx_runtime_1.jsxs)(FlexContainer, { children: [(0, jsx_runtime_1.jsx)(RegionSelectorHeader_1.default, { id: id }), (0, jsx_runtime_1.jsx)("div", { children: children }), (0, jsx_runtime_1.jsx)(RegionSelectorFooter_1.default, { id: id, onClose: onClose, onSelect: onSelect })] }));
};
exports.default = RegionSwitcherContent;
//# sourceMappingURL=RegionSwitcherContent.js.map